import { Course } from '../redux/coachingCenter/types'
import { CourseDetails } from '../redux/course/types'
import { DropdownListProps } from '../components/EditableDropdown/typings'

export const getAllCoursesDropdown = (
  courses: Array<CourseDetails>
): Array<DropdownListProps> => {
  const coursesList = courses.map((course: CourseDetails) => ({
    id: course?.value,
    name: course?.label
  }))
  return coursesList
}

const getCoursesDropdown = (
  courses: Array<Course>
): Array<DropdownListProps> => {
  const coursesList = courses.map((course: Course) => ({
    id: course?.id,
    name: course?.courseName
  }))
  return coursesList
}

export default getCoursesDropdown
